import React from 'react'
import { Link } from 'react-router-dom';
function ServiceSix() {
    return (
        <div>
            {/* rts-service area start */}
            <div className="rts-service-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <p className="pre-title">Our Services</p>
                                <h2 className="title">Accounting Services Designed for Modern Business</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--10">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            {/* single service for home six */}
                            <div className="single-service-home-six">
                                <div className="icon">
                                    <img src="assets/images/service/icon/19.svg" alt="" />
                                </div>
                                <div className="inner">
                                    <h5 className="title">Bookkeeping and Management Accounts</h5>
                                    <p className="disc">
                                        Accurate books and clear monthly packs with P&L, balance sheet and cash flow. We reconcile banks, handle receipts and flag issues early so you always know where you stand.
                                    </p>
                                    <Link to={'/services'} className="rts-btn btn-primary">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                            {/* single service for home six End */}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            {/* single service for home six */}
                            <div className="single-service-home-six">
                                <div className="icon">
                                    <img src="assets/images/service/icon/20.svg" alt="" />
                                </div>
                                <div className="inner">
                                    <h5 className="title">Taxation and VAT</h5>
                                    <p className="disc">
                                        Corporation tax, self assessment, VAT returns and Making Tax Digital. We file on time, reduce errors and plan legally to lower liabilities.
                                    </p>
                                    <Link to={'/services'} className="rts-btn btn-primary">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                            {/* single service for home six End */}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            {/* single service for home six */}
                            <div className="single-service-home-six">
                                <div className="icon">
                                    <img src="assets/images/service/icon/21.svg" alt="" />
                                </div>
                                <div className="inner">
                                    <h5 className="title">Payroll and Pensions</h5>
                                    <p className="disc">
                                        Fully managed payroll with RTI submissions, payslips, statutory pay and auto enrolment. Staff are paid on time and records stay HMRC ready.
                                    </p>
                                    <Link to={'/services'} className="rts-btn btn-primary">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                            {/* single service for home six End */}
                        </div>
                    </div>
                </div>
            </div>
            {/* rts-service area end */}
        </div>
    )
}

export default ServiceSix